<template>
  <section>
    <div class="row">
      <form id="filter-charts" class="col-12">
        <div class="col-12">
          <QueueFilterComponent></QueueFilterComponent>
        </div>
        <div class="col-12">
          <div class="input-group-prepend">
            <button type="submit" @click="update = !update" class="btn btn-primary"><i class="fa fa-search fa-fw"></i> Buscar dados</button>
          </div>
        </div>
      </form>

      <div class="col-md-12 tab-two-wrapper">
        <AbandonChart :update="update"></AbandonChart>

        <div class="dt-calls-abandon">
          <h3>Chamadas Abandonadas de Hoje</h3>

          <div class="alerts">
            <div id="alertLoading" hidden>
              <inline-alert-component type="primary" message="Aguarde, os dados estão sendo carregados."
                :dismiss="false"></inline-alert-component>
            </div>
            <div id="alertInfo" hidden>
              <inline-alert-component type="warning" message="Não há informações para exibir."
                :dismiss="false"></inline-alert-component>
            </div>
          </div>

          <table id="dt_calls_abandon_today" class="table display table-hover table-striped" style="width: 100%">
            <thead style="font-weight: bold">
              <tr role="row">
                <th class='text-center align-middle' style="border: 1px solid #fff;">Horário</th>
                <th class='text-center align-middle' style="border: 1px solid #fff;">Origem</th>
                <th class='text-center align-middle' style="border: 1px solid #fff;">Empresa</th>
                <th class='text-center align-middle' style="border: 1px solid #fff;">Fila</th>
                <th class='text-center align-middle' style="border: 1px solid #fff;">Tempo até abandono</th>
              </tr>
            </thead>
          </table>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
import AbandonChart from "../charts/AbandonChart.vue";
import QueueFilterComponent from "../filters/QueueFilterComponent.vue";

export default {
  name: "CallControlApp",
  components: {
    AbandonChart,
    QueueFilterComponent
  },
  data() {
    return {
      update: true,
    };
  },
};
</script>

<style scoped>
.dt-calls-abandon {
  padding: 20px;
  border-radius: 12px;
  box-shadow: -5px -5px 8px rgba(255, 255, 255, 1),
    -2px -2px 12px rgba(255, 255, 255, 0.5),
    inset 2px 2px 4px rgba(255, 255, 255, 0.1),
    5px 5px 8px rgba(0, 0, 0, 0.15);
}

.tab-one-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.wrapper-charts {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

#filter-charts {
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
}

.tab-two-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.sub-group {
  width: 45%;
}

.wrapper-group {
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.toogle-el {
  display: none;
}
</style>